import type { SurveysStore } from './interfaces'

import { isFullArray } from '@shared/lib/collections'

export const getters = {
  isLoading: (state: SurveysStore): SurveysStore['loading'] => state.loading,
  isExporting: (state: SurveysStore): SurveysStore['exporting'] => state.exporting,
  getDisciplineId: (state: SurveysStore): SurveysStore['disciplineId'] => state.disciplineId,
  getSurveys: (state: SurveysStore): SurveysStore['surveys'] => state.surveys,
  hasSurveys: (state: SurveysStore): boolean => isFullArray(state.surveys),
  getMeta: (state: SurveysStore): SurveysStore['meta'] => state.meta,
  getFilters: (state: SurveysStore): SurveysStore['filters'] => state.filters,
  getCurrentPage: (state: SurveysStore): SurveysStore['currentPage'] => state.currentPage,
  getPerPage: (state: SurveysStore): SurveysStore['perPage'] => state.perPage,
}
